import React, { FocusEventHandler, FormEventHandler } from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';

import Person from '../../shared/Person/Person';
import TextField from '../../shared/TextField/TextField';
import { ApplicantComponent, ApplicantProps } from '../../../models/applicant';
import { PHONE_PATTERN } from '../../../constants/REGEXP_PATTERNS';
import {
  getOnBlur,
  getOnChange,
  getOnCitizenshipChange,
  trimOnBlur,
} from '../../../helpers/handlers';
import { APPLICANT_FIELD_NAME } from '../../../constants/fieldNames';
import { getPersonPlaceholder } from '../../../helpers/getPlacelholder';
import {
  maxAcceptableDate,
  minAcceptableDate,
} from '../../../helpers/dateHelpers';
import DateField from '../../shared/DateField/DateField';
import { APPLICANT } from '../../../constants/modelNames';

interface Props extends ApplicantProps {
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
  handleFIOBlur: FocusEventHandler;
  onCitizenshipChange(value): void;
}

const Applicant: ApplicantComponent = function Applicant({
  onChange,
  onBlur,
  handleFIOBlur,
  onCitizenshipChange,
  ...applicant
}: Props) {
  const { birthdate, phone, email } = APPLICANT_FIELD_NAME;

  return (
    <Person
      person={applicant}
      onChange={onChange}
      model={APPLICANT}
      onBlur={onBlur}
      handleFIOBlur={handleFIOBlur}
      onCitizenshipChange={onCitizenshipChange}
    >
      <div className="PguFormGrid__row">
        <div className="PguFormGrid_col PguFormGrid__col_3">
          <DateField
            errorLocation="placeholder"
            value={applicant[birthdate].value}
            disabled={applicant[birthdate].disabled}
            error={applicant[birthdate].error}
            placeholder={getPersonPlaceholder('birthdate')}
            // TODO: add minDate and maxDate after calendar goes from moment to dayjs
            minDate={minAcceptableDate}
            maxDate={maxAcceptableDate}
            name={birthdate}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
        <div className="PguFormGrid_col PguFormGrid__col_3">
          <TextField
            placeholder={getPersonPlaceholder('phone')}
            inputProps={{
              type: 'tel',
              ...applicant[phone],
              name: phone,
              onChange,
              onBlur,
            }}
            maskOptions={{
              mask: PHONE_PATTERN.FOR_INPUT_MASK,
              showMaskOnHover: false,
            }}
          />
        </div>
        <div className="PguFormGrid_col PguFormGrid__col_3">
          <TextField
            placeholder={getPersonPlaceholder('email')}
            inputProps={{
              type: 'email',
              ...applicant[email],
              name: email,
              maxLength: 100,
              title: '',
              onChange,
              onBlur,
            }}
          />
        </div>
      </div>
    </Person>
  );
};

const mapStateToProps = ({ applicant }) => applicant;
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(APPLICANT, dispatch),
  onBlur: getOnBlur(APPLICANT, dispatch),
  handleFIOBlur: trimOnBlur(APPLICANT, dispatch),
  onCitizenshipChange: getOnCitizenshipChange(APPLICANT, dispatch),
});
const ApplicantContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Applicant);

export { ApplicantContainer as Applicant };
